export enum OrchestrationField {
  STRATEGY = 'strategy',
  MODE = 'mode',
  STOP = 'stop',
  RANKING = 'ranking',
}
